import { connect } from 'react-redux';
import ColorPicker from '../components/ColorPicker';
import { setColor } from '../actions';

const ColorPickerContainer = connect(
  state => ({
    color: state.engagement.campaign.color,
  }),
  { setColor }
)(ColorPicker);

export default ColorPickerContainer;
